import { combineReducers } from 'redux';
import auth from './authReducer';
import user from './userReducer';
import device from './deviceReducer';
import area from './areaReducer';
import modals from './modalReducer';

const rootReducer = combineReducers({
    auth,
    user,
    device,
    modals,
    area
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js